import { environment } from "../../environments/environment";
// const BASE_URL = 'http://localhost:8080/SmartclaimService/rest'; // local
// const BASE_URL = 'https://dev-smartclaim.thailife.com/SmartclaimService/rest'; // Dev
// const BASE_URL = 'https://sit-smartclaim.thailife.com/SmartclaimService/rest'; // SIT
// const BASE_URL = 'https://uat-smartclaim.thailife.com/SmartclaimService/rest'; // uat
// const BASE_URL = 'https://pre-smartclaim.thailife.com/SmartclaimService/rest'; // Pre prod
// const BASE_URL = 'https://smartclaim.thailife.com/SmartclaimService/rest';

const BASE_URL_ADMIN = '';

export const API_URL = {
    login: environment.BASE_URL + '/Login/checkLogin',
    getPerson: environment.BASE_URL + '/getPerson',
    userInfo: environment.BASE_URL + '/Login/checkLogin',
    searchInsured: environment.BASE_URL + '/SearchInsuredService/searchData',
    searchClaimStatus: environment.BASE_URL + '/claimStatus/getStatus',
    searchOPDDetail: environment.BASE_URL + '/opdDetail/getDetail',
    checkOPD: environment.BASE_URL + '/checkOPD/checkRight',
    checkIPD: environment.BASE_URL + '/checkIPD/checkRight',
    insertHexp: environment.BASE_URL + '/insertHexp/insertHexp',
    insertCauseCase: environment.BASE_URL + '/InsertCauseCase/insertData',
    searchBilling: environment.BASE_URL + '/SearchBilling/getBilling',
    searchSTP: environment.BASE_URL + '/totalCost/getDataSum',
    changePassword: environment.BASE_URL + '/changePassword/requestPassword',
    checkBillStatus: environment.BASE_URL + '/CheckBillStatus/getData',
    printDoc: environment.BASE_URL + '/printDoc/getDocByType',
    uploadFile: environment.BASE_URL + '/UploadFile/writeFile',
    checkWarning: environment.BASE_URL + '/checkWarning/checkData',
    getHospital: environment.BASE_URL + '/isTLMedicareHospital/getHospital',
    searchConcurrent: environment.BASE_URL + '/TLConcurrent/searchConcurrent',
    insertConcurrent: environment.BASE_URL + '/TLConcurrent/insertConcurrent',
    deleteBilling: environment.BASE_URL + '/SearchBilling/deleteBill',

    searchClaimOkDate: environment.BASE_URL + '/claimStatus/getClaimOkDate',
    searchErrorSTP: environment.BASE_URL + '/sendMail/error'
};

export const API_ADMIN_URL = {
    saveFeedback: BASE_URL_ADMIN + '/feedback/saveFeedback',
    getAllMenu: BASE_URL_ADMIN + '/menu/getAllMenu',
    getAttachFile: BASE_URL_ADMIN + '/document/getAttachFile',
    getFileFromPath: BASE_URL_ADMIN + '/approvedUser/getFileFromPath',
    insertUsertemp: BASE_URL_ADMIN + '/insertUserTemp',
};